import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import "../../styles/landingpage_updated.scss";

const CTAStatsSection = () => {
  return (
    <div className="creative-landing-content py-4">
      <section className="pt-5 propertyFraud_section d-flex flex-column align-items-center">
        <Container fluid className="px-3 px-md-5">
          <Row>
            <Col>
              <div className="card text-center linear_bg">
                <div className="card-body p-0">
                  <h2 className="privateGuardList card-title text-white text-center mb-4">
                    Let’s protect you against what is now one of the Fastest
                    Growing Crimes in America.
                  </h2>
                </div>
                <div className="mt-2">
                  <Row className="">
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <h4 className="value fw-700">$43.4 Trillion</h4>
                      <p className="label d-block d-md-none">
                        U.S Homes Value as of 2021
                      </p>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <h4 className="value fw-700">6,134%</h4>
                      <p className="label d-block d-md-none">
                        Property Fraud Increase{" "}
                      </p>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <h4 className="value fw-700">$9.9 Trillion</h4>
                      <p className="label d-block d-md-none">
                        Homeowner Equity as of 2021
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <p className="label d-none d-md-block">
                        U.S Homes Value as of 2021
                      </p>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <p className="label d-none d-md-block">
                        Property Fraud Increase{" "}
                      </p>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <p className="label d-none d-md-block">
                        Homeowner Equity as of 2021
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <Link
          className="text-white text-decoration-none mt-4"
          to="/property-risk-management"
        >
          <button className="button-width-mobile signin_button_v2 risk_assesment_button text-uppercase text-dark mt-2">
            Free risk assessment
          </button>
        </Link>
      </section>
    </div>
  );
};

export default CTAStatsSection;
